// envPrefix: ['REACT_APP_', 'VITE_'] в vite.config.ts — работает.
// Vite подставляет import.meta.env при сборке.
// Docker ARG/ENV остаются REACT_APP_* — docker-compose не меняется.

export const apiAddress =
    import.meta.env.REACT_APP_API_ADDRESS || 'http://localhost:8080/api/lk';
export const adminApiAddress =
    import.meta.env.REACT_APP_ADMIN_API_ADDRESS || 'http://localhost:8080/api/admin';
export const staticAddress =
    import.meta.env.REACT_APP_STATIC_ADDRESS || 'http://localhost/static';
export const reportsApiAddress =
    import.meta.env.REACT_APP_REPORTS_API_ADDRESS || 'http://localhost:5000';
export const monitorApiAddress =
    import.meta.env.REACT_APP_MONITOR_API_ADDRESS || 'http://localhost:5050/api';
export const cultureApiAddress =
    (import.meta.env.REACT_APP_CULTURE_API_ADDRESS as string) ||
    apiAddress.replace('/api/lk', '/api/culture');
export const forecastApiAddress =
    import.meta.env.REACT_APP_FORECAST_API_ADDRESS || 'http://localhost:10000/forecast/api';
